// src/App.js (인트로 비디오 적용 버전 + 히어로 배너 풀와이드 대응)
import React, { useState } from 'react';

// 컴포넌트들을 올바르게 import
import Navigation from './components/layout/Navigation';
import ContactModal from './components/layout/ContactModal';
import HomePage from './components/pages/HomePage';
import ExpertisePage from './components/pages/ExpertisePage';
import SolutionPage from './components/pages/SolutionPage';
import BusinessPage from './components/pages/BusinessPage';
import RegistrationPage from './components/pages/RegistrationPage';
import AboutPage from './components/pages/AboutPage';
import Intro from './components/layout/Intro'; // 1. Intro 컴포넌트 import
import SyncAIIntro from './components/layout/SyncAIIntro'; // 1-1. SyncAI 소개 영상 컴포넌트 import

// 상단에 풀와이드 히어로 배너를 쓰는 페이지 목록
// (이 페이지들은 main 태그의 좌우 패딩을 없애야 배너가 끝까지 채워집니다)
const FULL_WIDTH_PAGES = [
  'home',
  'fuel-cell',
  'digital-twin-expertise',
  'recipe-commercialization',
  'digital-twin-solution',
  'ai-recipe',
  'image-analysis',
  'about',
  'business',
  'registration'
];

const App = () => {
  // 'intro' = 메인 인트로 영상, 'syncai' = SyncAI 소개 영상, 'main' = 실제 사이트
  const [introStage, setIntroStage] = useState('intro');
  const [currentPage, setCurrentPage] = useState('home');
  const [showContact, setShowContact] = useState(false);

  const handleEnterApp = () => {
    setIntroStage('main');
  };

  const handleGoSyncAI = () => {
    setIntroStage('syncai');
  };

  const handleBackToIntro = () => {
    setIntroStage('intro');
  };

  const renderPage = () => {
    switch(currentPage) {
      case 'home':
        return <HomePage />;
      case 'fuel-cell':
      case 'digital-twin-expertise':
      case 'recipe-commercialization':
        return <ExpertisePage pageId={currentPage} />;
      case 'digital-twin-solution':
      case 'ai-recipe':
      case 'image-analysis':
        return <SolutionPage pageId={currentPage} />;
      case 'business':
        return <BusinessPage onContactClick={() => setShowContact(true)} />;
      case 'registration':
        return <RegistrationPage />;
      case 'about':
        return <AboutPage />;
      default:
        return <HomePage />;
    }
  };

  // 컨테이너 스타일 - 화면 크기와 무관하게 항상 좌우를 꽉 채움
  // (1200px maxWidth를 없애서 PC 큰 화면에서도 좌우에 흰 여백이 남지 않도록 처리)
  const containerStyle = {
    minHeight: '100vh',
    backgroundColor: '#0f172a',
    width: '100%',
    display: 'flex',
    flexDirection: 'column'
  };

  // 메인 스타일 수정 - 고정 높이 대신 flex로 남는 공간을 채움
  const mainStyle = {
    padding: FULL_WIDTH_PAGES.includes(currentPage) ? '0' : '1.5rem',
    overflowY: 'auto',
    flex: 1
  };

  // 4. introStage에 따라 메인 인트로 / SyncAI 소개 / 실제 앱을 렌더링
  if (introStage === 'intro') {
    return <Intro onEnter={handleEnterApp} onSyncAI={handleGoSyncAI} />;
  }

  if (introStage === 'syncai') {
    return <SyncAIIntro onEnter={handleEnterApp} onBack={handleBackToIntro} />;
  }

  return (
    <div style={containerStyle}>
      <Navigation
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        onContactClick={() => setShowContact(true)}
      />

      <main style={mainStyle}>
        {renderPage()}
      </main>

      {showContact && (
        <ContactModal onClose={() => setShowContact(false)} />
      )}
    </div>
  );
};

export default App;
